<template lang="html">
  <article>
    <portal></portal>
    <launch-preview></launch-preview>
    <mapchart v-if='this.$route.params.type === "web"'></mapchart>
  <galaxy></galaxy>
  </article>
</template>

<script>
import launchPreview from './launchPreview/launchPreview.vue'
import portal from './portal/portal'
import galaxy from './galaxy/galaxy'
import mapchart from './mapchart/mapchart'
export default {
  data () {
    return {
      // todo
    }
  },
  components: {
    launchPreview,
    portal,
    mapchart,
    galaxy
  }
}
</script>

<style lang="less">
.show-top{
  height: 600px;
  width: 100%;
}
.pc-bg{
  background: url(/static/bg-mobile.jpg) center top no-repeat;
}
.mb-bg{
  background: url(/static/bg-web.jpg) center top no-repeat;
}
</style>



// WEBPACK FOOTER //
// medianav.vue?e948d3ae